import React from 'react';
import Menu from 'components/Menu/Menu';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import Button from './Button';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  label: {
    justifyContent: 'space-between',
    display: 'flex',
  },
  icon: open => ({
    color: open ? theme.palette.primary.main : theme.palette.secondary['300'],
    transform: open ? 'rotate(180deg)' : 'none',
    transition: 'all 0.3s',
  }),
}));


const ButtonMenu = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    props.btnClick(event.currentTarget);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    props.btnClick(null);
    setAnchorEl(null);
  };

  React.useEffect(() => {
    if (!props.open) {
      handleClose();
    }
  }, [props.open]);

  const {
    color, variant, size,
    className, disabled, open,
  } = props;
  const classes = useStyles(Boolean(anchorEl));

  return (
    <div className={className} onScroll={props.onScroll}>
      <Button
        color={color}
        variant={variant}
        aria-controls="btn-menu"
        aria-haspopup="true"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownRoundedIcon className={classes.icon} />}
        size={size}
        disabled={disabled}
        classes={{
          root: classes.root,
          label: classes.label,
        }}
      >
        {props.btnText}
      </Button>
      <Menu
        id="btn-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl) || open}
        onClose={handleClose}
      >
        {props.children}
      </Menu>
    </div>
  );
};

ButtonMenu.propTypes = {
  open: PropTypes.bool,
  btnText: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
  classes: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  variant: PropTypes.string,
  btnClick: PropTypes.func,
  onScroll: PropTypes.func,
};

ButtonMenu.defaultProps = {
  btnText: 'Open menu',
  size: 'Medium',
  className: '',
  disabled: false,
  color: 'white',
  variant: 'outlined',
  open: null,
  btnClick: () => {},
  onScroll: () => {},
};

export default ButtonMenu;
